import { Dayjs } from "dayjs"
import { PrizeDrawEntryWinnerStatus } from "@/api/backofficeRest/generated/model"

export interface IDrawWinner {
  id: string
  /** Core billing account id; identifies the same account across draws and other services. */
  billingAccountId: string
  /** Junifer account number of the winner; links to their Nova customer page. */
  accountNumber: string
  /** Reward this winner won; resolved to a prize name against the draw's rewards. */
  prizeDrawRewardId: string | null
  /** Winner's surname, or 'Anonymous' when they have opted out of name visibility. */
  surname: string
  county: string
  nameVisibilityOptOut: boolean
  status: PrizeDrawEntryWinnerStatus
  rewardProcessError: string | null
  /** Completion date of the most recent earlier draw this account won, else null. */
  lastWonDate: Dayjs | null
}

/** Prizes have been granted once any winner has been rewarded. */
export const arePrizesGranted = (winners: IDrawWinner[]): boolean =>
  winners.some(
    (winner) => winner.status === PrizeDrawEntryWinnerStatus.REWARDED,
  )

/** A single staged winner edit, surfaced in the Review & Save modal. */
export interface IWinnerChange {
  id: string
  surname: string
  fromCounty: string
  toCounty: string
  countyChanged: boolean
  fromAnon: boolean
  toAnon: boolean
  anonChanged: boolean
}
